import { PageLocatorMap } from '../types/PageLocatorMap';

export const mailCodeOfferPage = {
  footer: {
    root: 'mail-code-offer-page.footer.root',
  },
  form: {
    h1: 'mail-code-offer-page.form.heading1',
    h2: 'mail-code-offer-page.form.heading2',
    root: 'mail-code-offer-page.form.root',
    submitButton: 'mail-code-offer-page.form.submit-button',
  },
  header: {
    root: 'mail-code-offer-page.header.root',
  },
} as const satisfies PageLocatorMap;
